/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigUpdateRequest extends models.ServiceNowCmdbConfigBaseRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigUpdateRequest>): ServiceNowCmdbConfigUpdateRequest {
        let obj = Object.assign(new ServiceNowCmdbConfigUpdateRequest(), model);
        ServiceNowCmdbConfigUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigUpdateRequest>): ServiceNowCmdbConfigUpdateRequest {
        if (!model) return null;
        return ServiceNowCmdbConfigUpdateRequest.newInstance(<ServiceNowCmdbConfigUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigUpdateRequest) {
        if (!obj) return;

        models.ServiceNowCmdbConfigUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigUpdateRequest): boolean {
        if (models.ServiceNowCmdbConfigBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            for (let key in this.configuration) {
                let val = this.configuration[key];
                if (val) {
                    models.ServiceNowCmdbServiceConfig.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Id of the ServiceNow Account
     */
    cmdb_account_id: string;

    /**
     * Name of the Cmdb Service
     */
    cmdb_service: string;

    /**
     * ServiceNow Cmdb Sync Configuration, indexed by CloudServiceName
     */
    configuration: { [key: string]: models.ServiceNowCmdbServiceConfig; };

}
